import type { PublicEvent } from "@homesite/api-contract";
import { queryKeys } from "@homesite/queries";
import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../lib/ApiClientContext";

export interface UseRecentEventsData {
	events: PublicEvent[];
	total: number;
	loading: boolean;
	error: Error | null;
}

/**
 * Fetches a paginated window of the most recent events across all loans.
 * Used as the default view for /events when no hash query is supplied.
 */
export function useRecentEvents(limit = 20): UseRecentEventsData {
	const client = useApiClient();

	const query = useQuery({
		queryKey: queryKeys.publicVerification.events.list(1, limit),
		queryFn: async () => {
			const result = await client.publicVerification.listEvents({
				query: { page: 1, limit },
			});
			if (result.status !== 200) {
				throw new Error("Failed to load recent events");
			}
			return result.body;
		},
	});

	return {
		events: query.data?.items ?? [],
		total: query.data?.total ?? 0,
		loading: query.isLoading,
		error: query.error,
	};
}
